<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app-peer',
    
    mounted() {
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = this.$store.state.api.authUrl+'/OAuthClient/script/fd632103d495686ce6322befbd2741f9.v1.js'
        script.referrerPolicy = 'origin'
        script.onload = () => {
            this.$bus.$emit('oAuthClientReady')
            this.peer.$(() => {
                setTimeout(() => {
                    platformApi.initialize()
                }, 500)
            })
        }
        
        document.head.appendChild(script)
    }
}
</script>
